import * as log from "loglevel";

export enum PerformanceTransactionName {
  DEPLOY_APPLICATION = "DEPLOY_APPLICATION",
  DATA_TREE_EVALUATION = "DATA_TREE_EVALUATION",
  CONSTRUCT_UNEVAL_TREE = "CONSTRUCT_UNEVAL_TREE",
  CONSTRUCT_CANVAS_DSL = "CONSTRUCT_CANVAS_DSL",
  CREATE_DEPENDENCIES = "CREATE_DEPENDENCIES",
  SORTED_DEPENDENCY_EVALUATION = "SORTED_DEPENDENCY_EVALUATION",
  SET_WIDGET_LOADING = "SET_WIDGET_LOADING",
  VALIDATE_DATA_TREE = "VALIDATE_DATA_TREE",
  EXECUTE_PAGE_LOAD_ACTIONS = "EXECUTE_PAGE_LOAD_ACTIONS",
  EVALUATE_BINDING = "EVALUATE_BINDING",
  ENTITY_EXPLORER_ENTITY = "ENTITY_EXPLORER_ENTITY",
  ENTITY_EXPLORER = "ENTITY_EXPLORER",
  CLOSE_SIDE_PANE = "CLOSE_SIDE_PANE",
  OPEN_ACTION = "OPEN_ACTION",
  EDITOR_MOUNT = "EDITOR_MOUNT",
  SIDE_BAR_MOUNT = "SIDE_BAR_MOUNT",
  CANVAS_MOUNT = "CANVAS_MOUNT",
  EXECUTE_ACTION = "EXECUTE_ACTION",
  CHANGE_API_SAGA = "CHANGE_API_SAGA",
  SYNC_PARAMS_SAGA = "SYNC_PARAMS_SAGA",
  RUN_API_CLICK = "RUN_API_CLICK",
  RUN_QUERY_CLICK = "RUN_QUERY_CLICK",
  FETCH_ACTIONS_API = "FETCH_ACTIONS_API",
  FETCH_PAGE_LIST_API = "FETCH_PAGE_LIST_API",
  FETCH_PAGE_ACTIONS_API = "FETCH_PAGE_ACTIONS_API",
  FETCH_PAGE_API = "FETCH_PAGE_API",
  SAVE_PAGE_API = "SAVE_PAGE_API",
  UPDATE_ACTION_API = "UPDATE_ACTION_API",
  OPEN_PROPERTY_PANE = "OPEN_PROPERTY_PANE",
  REFACTOR_ACTION_NAME = "REFACTOR_ACTION_NAME",
  USER_ME_API = "USER_ME_API",
  SIGN_UP = "SIGN_UP",
  LOGIN_CLICK = "LOGIN_CLICK",
}

export enum PerformanceTagNames {
  PAGE_ID = "pageId",
  APP_ID = "appId",
  APP_MODE = "appMode",
  TRANSACTION_SUCCESS = "transaction.success",
}

// Sentry performance tracing removed in modernization.
// Lightweight no-op tracker that preserves the public API and debug logging.
class PerformanceTracker {
  static startTracking = (
    eventName: PerformanceTransactionName,
    _data?: any,
    skipLog = false,
  ) => {
    if (!skipLog) {
      log.debug(eventName + " Start Tracking");
    }
  };

  static stopTracking = (eventName?: PerformanceTransactionName) => {
    if (eventName) {
      log.debug(eventName + " Stop Tracking");
    }
  };

  static startAsyncTracking = (
    eventName: PerformanceTransactionName,
    _data?: any,
    _uniqueId?: string,
    _parentEventId?: string,
    skipLog = false,
  ) => {
    if (!skipLog) {
      log.debug("Async " + eventName + " Start Tracking");
    }
  };

  static stopAsyncTracking(eventName: PerformanceTransactionName) {
    log.debug("Async " + eventName + " Stop Tracking");
  }
}

export default PerformanceTracker;
